<template>
  <v-container>
    <v-snackbar
      v-model="snackbar"
      xs12
      multi-line
      :timeout="timeout"
      top
      color="orange"
    >
      {{ alertmessage }}
      <v-btn
        color="white"
        text
        @click="snackbar = false"
      >
        Close
      </v-btn>
    </v-snackbar>
    <v-row>
      <v-col>
        <v-progress-linear
          :active="loading"
          :indeterminate="loading"
          absolute
          color="primary"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <base-material-card
          v-if="!loading"
          color="primary"
          icon="mdi-bank"
          inline
        >
          <template v-slot:after-heading>
            <div class="display-2 font-weight-light">
              Credit Management
            </div>
          </template>
          <v-col cols="12">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            />
          </v-col>
          <v-row>
            <v-col
              sm="12"
            >
              <v-card
                class="pa-2"
                outlined
                tile
              >
                <v-toolbar
                  flat
                  color="white"
                >
                  <v-dialog v-model="dialog">
                    <v-card>
                      <v-card-title>
                        <span class="headline">{{ formTitle }}</span>
                      </v-card-title>
                      <v-card-text>
                        <v-container>
                          <v-row>
                            <v-col
                              cols="12"
                              sm="6"
                              md="6"
                            >
                              <v-text-field
                                v-model="editedItem.idnum"
                                label="Site Name"
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              sm="6"
                              md="6"
                            >
                              <v-text-field
                                v-model="editedItem.address"
                                label="Address"
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              sm="12"
                              md="12"
                            >
                              <v-select
                                v-model="editedItem.locationTags"
                                :items="locationTags"
                                attach
                                chips
                                label="Location Tags"
                                multiple
                                disabled
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              sm="12"
                              md="12"
                            >
                              <v-switch
                                v-model="editedItem.provCredit"
                                label="Provisional Credit"
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              sm="12"
                              md="6"
                            >
                              <v-select
                                v-if="editedItem.provCredit"
                                v-model="editedItem.creditprovider"
                                :items="creditprovider"
                                label="Credit Provider"
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              sm="12"
                              md="6"
                            >
                              <v-text-field
                                v-if="editedItem.provCredit"
                                v-model="editedItem.creditproviderapikey"
                                label="Customer API Key"
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              sm="12"
                              md="6"
                            >
                              <v-text-field
                                v-if="editedItem.provCredit"
                                v-model="editedItem.creditproviderId"
                                label="Customer ID Number"
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              sm="12"
                              md="6"
                            >
                              <v-text-field
                                v-if="editedItem.provCredit"
                                v-model="editedItem.creditproviderLocationID"
                                label="Location ID Number"
                              />
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-card-text>

                      <v-card-actions>
                        <v-spacer />
                        <v-btn
                          color="blue darken-1"
                          @click="close"
                        >
                          Cancel
                        </v-btn>
                        <v-btn
                          color="blue darken-1"
                          :disabled="!formIsValid"
                          @click="save"
                        >
                          Save
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                  <v-spacer />
                </v-toolbar>

                <v-data-table
                  :headers="headers"
                  :search="search"
                  :items="currentmachines"
                  item-key="idnum"
                  class="elevation-1"
                  :single-expand="singleExpand"
                  :expanded.sync="expanded"
                >
                  <template v-slot:items="props">
                    <td class="text-left">
                      {{ props.item.idnum }}
                    </td>
                    <td class="text-left">
                      {{ props.item.group }}
                    </td>
                    <td class="text-left">
                      {{ props.item.address }}, {{ props.item.city }} {{ props.item.zipcode }}
                    </td>
                    <td class="text-left">
                      {{ props.item.sitecontactnumber }}
                    </td>
                    <td class="text-left">
                      {{ props.item.sitecontactname }}
                    </td>
                    <td class="text-left">
                      {{ props.item.wifipw }}
                    </td>
                    <td class="text-left">
                      {{ props.item.wifiaccess }}
                    </td>
                    <td class="text-left">
                      {{ props.item.timezone }}
                    </td>
                    <td class="text-left">
                      {{ props.item.time_open }} Hrs
                    </td>
                    <td class="text-left">
                      {{ props.item.time_close }} Hrs
                    </td>
                    <td class="text-left">
                      {{ props.item.time_eod }} Hrs
                    </td>
                  </template>
                  <template
                    v-if="userallowed"
                    v-slot:item.action="{ item }"
                  >
                    <v-icon

                      color="primary"
                      size="20"
                      @click="editItem(item)"
                    >
                      mdi-square-edit-outline
                    </v-icon>
                  </template>
                  <template v-slot:no-data>
                    <v-btn color="primary">
                      Reset
                    </v-btn>
                  </template>
                </v-data-table>
              </v-card>
            </v-col>
          </v-row>
        </base-material-card>

        <v-spacer />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  // Components

  export default {
    data: () => ({
      search: '',
      dialog: false,
      time: null,
      newgroup: '',
      snackbar: false,
      syncChange: false,
      changeProvider: ['Safe and Sound'],
      singleExpand: true,
      expanded: [],
      timeout: 5000,
      alertmessage: '',
      currentgroups: '',
      showchange: false,
      singleSelect: false,
      headers_change: [
        { text: 'Label', align: 'left', value: 'label', sortable: false },
        { text: 'Group', align: 'left', value: 'group', sortable: false },
      ],
      sitetype: ['physical', 'virtual', 'postal'],
      scheduletype: ['daily', 'weekly', 'biweekly', 'monthly'], // we calc iso week as some months shorter, some longer
      supportedTimezones: ['EST', 'CST', 'MST', 'PST', 'GMT'],
      locationTags: ['Restaurants', 'Retail', 'Parking', 'Car Wash', 'Other'],
      safeType: ['Single Note', 'Tray Fed', 'High Speed'],
      noteCapacity: ['500', '1000', '2000', '4000', '10000', '20000'],
      provCredit: false,
      creditprovider: ['Fiserv', 'CashConnect', 'DTSConnex'],
      creditproviderId: '',
      externalsafe: false,
      menu2: false,
      menu3: false,
      menu4: false,
      menu5: false,
      modal2: false,
      loading: false,
      headers: [
        { text: 'Site Name', value: 'idnum', align: 'left', width: 200 },
        { text: 'Provider', value: 'creditprovider', align: 'left' },
        { text: 'Address', value: 'address', align: 'left', width: 200 },
        { text: 'Time Zone', value: 'timezone', align: 'center' },
        { text: 'EOD', value: 'time_eod', align: 'center' },
        { text: 'Actions', value: 'action', align: 'center', sortable: false }
      ],
      sites: [],
      editedIndex: -1,
      editedItem: {
        idnum: '',
        crypto_idnum: '',
        originalidnum: '',
        sitekey: '',
        sitetype: '',
        schedule: '',
        address: '',
        city: '',
        state: '',
        zipcode: '',
        group: '',
        changeSystemID: '',
        changeProvider: '',
        allowedusers: null,
        changeorderprofiles: [],
        locationTags: null,
        safeType: 'none',
        noteCapacity: '',
        provCredit: false,
        creditprovider: '',
        creditproviderId: '',
        creditproviderLocationID: '',
        creditproviderapikey: '',
        wifipw: '',
        externalsafe: false,
        wifiaccess: '',
        country: '',
        sitecontactnumber: '',
        sitecontactname: '',
        supportemail: '',
        supportnumber: '',
        timezone: '',
        time_open: '',
        time_close: '',
        time_eod: '',
        time_deposit_summary: ''
      },
      defaultItem: {
        idnum: '',
        crypto_idnum: '',
        originalidnum: '',
        address: '',
        sitekey: '',
        sitetype: '',

        schedule: '',
        city: '',
        state: '',
        zipcode: '',
        externalsafe: false,
        wifipw: '',
        wifiaccess: '',
        group: '',
        changeSystemID: '',
        changeProvider: '',
        allowedusers: [],
        changeorderprofiles: [],
        locationTags: [],
        safeType: '',
        noteCapacity: '',
        provCredit: false,
        creditprovider: '',
        creditproviderId: '',
        creditproviderLocationID: '',
        country: '',
        sitecontactnumber: '',
        sitecontactname: '',
        supportemail: '',
        supportnumber: '',
        timezone: '',
        time_open: '',
        time_close: '',
        time_eod: '',
        time_deposit_summary: ''
      }
    }),

    computed: {
      formIsValid () {
        return this.editedItem.idnum !== '' &&
          this.editedItem.address !== '' &&
          this.editedItem.city !== '' &&
          this.editedItem.state !== '' &&
          this.editedItem.zipcode !== '' &&
          this.editedItem.group !== '' &&
          this.editedItem.sitecontactnumber !== '' &&
          this.editedItem.sitecontactname !== '' &&
          this.editedItem.supportemail !== '' &&
          this.editedItem.supportnumber !== '' &&
          this.editedItem.timezone !== '' &&
          this.editedItem.time_open !== '' &&
          this.editedItem.time_close !== '' &&
          this.editedItem.time_eod !== ''
      },
      getcurrentgroups () {
        this.$log.debug('groups', this.$store.getters.usergroups)
        this.currentgroups = this.$store.getters.usergroups
        return this.currentgroups
      },
      grouplist () {
        // return []
        let groups = this.$store.getters.usergroups.map(
          group => group.name
        )
        return groups
      },
      changeorderprofilelist () {
        return this.$store.getters.getLoadedChangeProfiles
      },
      getstates () {
        let state_hash = [
          'AL',
          'AK',
          'AS',
          'AZ',
          'AR',
          'CA',
          'CO',
          'CT',
          'DE',
          'DC',
          'FM',
          'FL',
          'GA',
          'GU',
          'HI',
          'ID',
          'IL',
          'IN',
          'IA',
          'KS',
          'KY',
          'LA',
          'ME',
          'MH',
          'MD',
          'MA',
          'MI',
          'MN',
          'MS',
          'MO',
          'MT',
          'NE',
          'NV',
          'NH',
          'NJ',
          'NM',
          'NY',
          'NC',
          'ND',
          'MP',
          'OH',
          'OK',
          'OR',
          'PW',
          'PA',
          'PR',
          'RI',
          'SC',
          'SD',
          'TN',
          'TX',
          'UT',
          'VT',
          'VI',
          'VA',
          'WA',
          'WV',
          'WI',
          'WY'
        ]
        return state_hash
      },
      userallowed () {
        if (parseInt(this.$store.getters.user.level) >= 500 || this.$store.getters.user.status === 'corporate') {
          this.$log.debug('user allowed', this.$store.getters.user.level)

          return true
        }
        this.$log.debug('user NOT allowed', this.$store.getters.user.level)

        return false
      },
      formTitle () {
        return this.editedIndex === -1 ? 'New Site' : 'Edit Site Credit'
      },
      currentmachines () {
        this.sites = this.$store.getters.loadedSites
        return this.sites
      }
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
      loading (val) {
        if (!val) return

        setTimeout(() => (this.loading = false), 1000)
      }
    },
    created () {
      this.loading = true
      this.$store.dispatch('loadunits')
      this.$store.dispatch('loadsiteProfiles')
      this.$store.dispatch('loadSiteConfigs')
      this.$store.dispatch('loadUserProfiles')
      this.$store.dispatch('loadChangeProfile')

      this.$log.debug('SITES LOADED: ', this.$store.getters.loadedSites)
      this.sites = this.$store.getters.loadedSites
      this.tokens = this.$store.getters.loadedTokens
      this.$log.debug('this sites is: ', this.sites)
      console.log(this.sites)
    },

    methods: {
      userlist (group) {
        this.$log.debug('%%%%% group passed is ', group)
        let people = this.$store.getters.userprofiles
        this.$log.debug('people rec is ', people)
        let usersfromgroup = people.filter(person => person.group === group)
        return usersfromgroup.map(usr => usr.email)
      },
      addgroup () {
        this.$log.debug('want to add group ', this.newgroup)
        if (this.newgroup) {
          // this.currentgroups.push(this.newgroup)
          this.$log.debug('I am adding group ', this.newgroup)
          this.$store.dispatch('createUserGroup', this.newgroup)
          // make sure to load on a good add to the db
          this.$store.dispatch('loadUserGroups')
          this.newgroup = ''
        }
      },
      removeGroup (index) {
        let numelements = 1
        let grp = this.currentgroups[index]
        this.currentgroups.splice(index, numelements)
        this.$store.dispatch('removeUserGroup', grp)
        this.$store.dispatch('loadUserGroups')
      },
      editItem (item) {
        this.editedIndex = this.sites.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
        this.$log.debug('this is an edit')
      },
      close () {
        this.dialog = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },

      save () {
        this.$log.debug(' can we save this ? ', this.editedItem.idnum)
        this.editedItem.idnum = this.editedItem.idnum.trim()
        this.editedItem.idnum = this.editedItem.idnum.replace(/\t/g, '')
        if (this.editedItem.idnum === '') {
          this.alertmessage = '# . $ are not allowed in a site name'
          this.snackbar = true
          this.close()
          return
        }
        // check unallowed chars?
        let notallowedchars = ''
        notallowedchars = this.editedItem.idnum.match(/\\t|[#\$\.]/gi)
        this.$log.debug('notallowedchars ', notallowedchars)
        if (notallowedchars) {
          this.alertmessage = '# . $ are not allowed in a site name'
          this.snackbar = true
          this.close()
          return
        }
        if (!this.editedItem.creditproviderId) {
          this.editedItem.creditproviderId = ''
        }
        if (!this.editedItem.changeorderprofiles) {
          this.editedItem.changeorderprofiles = []
        }
        if (!this.editedItem.creditproviderLocationID) {
          this.editedItem.creditproviderLocationID = ''
        }
        if (!this.editedItem.creditproviderapikey) {
          this.editedItem.creditproviderapikey = ''
        }
        if (!this.editedItem.creditprovider) {
          this.editedItem.creditprovider = ''
        }
        if (!this.editedItem.safeType) {
          this.editedItem.safeType = ''
        }
        if (!this.editedItem.noteCapacity) {
          this.editedItem.noteCapacity = ''
        }
        if (!this.editedItem.state) {
          this.editedItem.state = 'NY'
        }
        if (!this.editedItem.locationTags) {
          this.editedItem.locationTags = []
        }
        if (!this.editedItem.provCredit) {
          this.editedItem.provCredit = false
        }
        if (!this.editedItem.time_deposit_summary) {
          this.editedItem.time_deposit_summary = ''
        }
        if (!this.editedItem.changeProvider) {
          this.editedItem.changeProvider = ''
        }
        if (!this.editedItem.changeSystemID) {
          this.editedItem.changeSystemID = ''
        }
        const machineData = {
          idnum: this.editedItem.idnum.trim(),
          address: this.editedItem.address.trim(),
          sitekey: this.editedItem.sitekey.trim(),
          group: this.editedItem.group.trim(),
          allowedusers: this.editedItem.allowedusers,
          changeSystemID: this.editedItem.changeSystemID,
          changeProvider: this.editedItem.changeProvider,
          changeorderprofiles: this.editedItem.changeorderprofiles,
          safeType: this.editedItem.safeType,
          noteCapacity: this.editedItem.noteCapacity,
          locationTags: this.editedItem.locationTags,
          provCredit: this.editedItem.provCredit,
          creditprovider: this.editedItem.creditprovider,
          creditproviderId: this.editedItem.creditproviderId.trim(),
          creditproviderLocationID: this.editedItem.creditproviderLocationID.trim(),
          creditproviderapikey: this.editedItem.creditproviderapikey.trim(),
          wifipw: this.editedItem.wifipw.trim(),
          wifiaccess: this.editedItem.wifiaccess.trim(),
          city: this.editedItem.city.trim(),
          state: this.editedItem.state.trim(),
          zipcode: this.editedItem.zipcode.trim(),
          sitecontactnumber: this.editedItem.sitecontactnumber.trim(),
          sitecontactname: this.editedItem.sitecontactname.trim(),
          supportemail: this.editedItem.supportemail.trim(),
          supportnumber: this.editedItem.supportnumber.trim(),
          timezone: this.editedItem.timezone.trim(),
          time_open: this.editedItem.time_open,
          time_close: this.editedItem.time_close,
          time_eod: this.editedItem.time_eod,
          time_deposit_summary: this.editedItem.time_deposit_summary
        }
        this.$log.debug('checking ', this.editedItem.originalidnum, ' to ', this.editedItem.idnum)

        if (this.editedIndex > -1) {
          this.$log.debug('we saved on edit here')
          this.$log.debug('passing SITE KEY ', machineData.sitekey)
          if (this.editedItem.idnum !== this.editedItem.originalidnum) {
            // clone the profile to the new name
            this.$log.debug('cloning ', this.editedItem.originalidnum, ' to ', this.editedItem.idnum)
          }
          let rec = {
            originalidnum: this.editedItem.originalidnum,
            newidnum: this.editedItem.idnum,
            group: this.editedItem.group
          }
          this.$store.dispatch('clonesiteProfile', rec)
          this.$store.dispatch('updateMachineConfig', machineData)

          Object.assign(this.sites[this.editedIndex], this.editedItem)
        } else {
          this.$log.debug('before save')
          this.$store.dispatch('createMachineConfig', machineData)
          this.sites.push(this.editedItem)
        }
        this.$store.dispatch('loadunits')
        this.$store.dispatch('loadsiteProfiles')
        this.$store.dispatch('loadSiteConfigs')
        this.$store.dispatch('loadUserProfiles')
        this.sites = this.$store.getters.loadedSites
        this.tokens = this.$store.getters.loadedTokens
        this.close()
      }
    }
  }
</script>
<style>
  .card--flex-toolbar {
    margin-top: -64px;
  }
</style>
